module.exports = __webpack_public_path__ + "img/058-myanmar.eb7cabbb.svg";